<!--
 * @Author: 张天昊
 * @Date: 2024-11-13 10:51:38
 * @LastEditTime: 2024-11-15 17:41:50
 * @LastEditors: 张天昊
 * @Description: 
 * @FilePath: /Mobile/src/pages/index/components/PrivacyDetailContent.vue
-->
<template>
  <div style="margin-top: 6.4vw">
    <div class="title">
      {{ getTitle }}
    </div>
    <div class="box">
      <div class="content">
        <div class="content__start">使用目的</div>
        <div class="content__end">{{ fieldData.desc.purpose }}</div>
      </div>
      <div class="divider"></div>
      <div class="content">
        <div class="content__start">使用场景</div>
        <div class="content__end">{{ fieldData.desc.scene }}</div>
      </div>
      <div class="divider"></div>
      <div class="content">
        <div class="content__start">收集情况</div>
        <div class="content__end">{{ fieldData.enable_name }}</div>
      </div>
      <div class="divider"></div>
      <div class="content">
        <div class="content__start">信息内容</div>
        <div v-if="fieldData.url && fieldData.url.length > 0">
          <div class="content__end__link" v-on:click="openPage(fieldData.url)">
            {{ getDisplayContent() }}
          </div>
        </div>
        <div v-else>
          <div class="content__end">{{ getDisplayContent() }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyDetailContent',
  data() {
    return {};
  },
  props: {
    fieldData: Object,
    index: Number
  },
  mounted() {
    console.log('----- field data', this.fieldData);
  },

  methods: {
    getDisplayContent: function () {
      if (this.fieldData) {
        if (
          this.fieldData.displayContent &&
          this.fieldData.displayContent.length > 0
        ) {
          return this.fieldData.displayContent;
        } else {
          return '-';
        }
      }
    },

    openPage(schema) {
      if (!schema) return;
      console.log('----- url = ', schema);
      // 一机管没有实现openPage
      // openWindow支持传原生schema
      window.yyn.app.invoke('openWindow', {
        openUrl: schema
      });
    }
  },

  computed: {
    getTitle() {
      return this.index + 1 + '、' + this.fieldData.desc.field_name;
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  font-size: 14px;
  color: #333333;
  font-weight: 600;
}

.box {
  width: 100%;
  border: solid 1px #eee;
  margin-top: 12px;

  .content {
    display: flex;
    flex-direction: row;
    .content__start {
      text-align: start;
      padding: 8px 12px;
      flex-shrink: 0;
      background-color: #f8f9fc;
      font-size: 14px;
      color: #333333;
    }

    .content__end {
      text-align: start;
      padding: 8px 12px;
      width: 100%;
      height: 100%;
      font-size: 14px;
      color: #333333;
      line-height: 1.67;
      word-break: break-all;
    }

    .content__end__link {
      text-align: start;
      padding: 8px 12px;
      width: 100%;
      height: 100%;
      font-size: 14px;
      color: #26c080;
      line-height: 1.67;
      word-break: break-all;
    }
  }
  .divider {
    width: 100%;
    height: 1px;
    background-color: #eee;
  }
}
</style>
